import validate from "/data/code/equirize/prod/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/data/code/equirize/prod/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "bond-signup-gate": () => import("/data/code/equirize/prod/middleware/bond-signup-gate.js")
}